import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const NumberCountryDropdown = ({
    data,
    previousEditNumberData,
    setCurrentNumber,
    errors,
    touched,
    darkMode,
}) => {
    const handleSelectChange = (item) => {
        setCurrentNumber((prev) => ({
            ...prev,
            countryID: item.id,
        }));
    };

    const [isHovered, setIsHovered] = useState(false);
    const fieldName = 'formValues[0].countryID';
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                errors?.formValues?.[0]?.countryID &&
                touched?.formValues?.[0]?.countryID
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                sx={{ ...stackStyling(true), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Countries <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose an available country to assign the number to.
                        This is required
                    </Text>
                </Box>
                <Stack direction="column" spacing={0} flex={1}>
                    <Stack direction="row">
                        <Field
                            component={DropDown}
                            id={fieldName}
                            name={fieldName}
                            shownValue="name"
                            currentId={data?.countryID}
                            handleSelectChange={handleSelectChange}
                            darkMode={darkMode}
                            data={data?.countries}
                            validate={(value) => {
                                if (
                                    !value ||
                                    value === '' ||
                                    value === 'null'
                                ) {
                                    return 'Country is required';
                                }
                            }}
                            data-walkthroughid={
                                walkthroughIds.editNumbersGeneral
                                    .editPlatformNumbers
                            }
                        />
                        {isHovered && (
                            <FieldToolTip
                                label="List of available countries to assign the number to"
                                ariaLabel="numbers-countries-dropdown-tooltip"
                                right="25px"
                                top="23px"
                            />
                        )}
                    </Stack>
                    {previousEditNumberData?.countryID &&
                        previousEditNumberData.countryID !== 'null' &&
                        data?.countryID &&
                        previousEditNumberData.countryID !== data.countryID && (
                            <Text
                                color="orange.400"
                                fontSize="xs"
                                mt={2}
                                maxWidth={400}>
                                Changing countries may not automatically reflect
                                to UCaaS platform. It is recommended to remove
                                and readd trunk to apply this update
                            </Text>
                        )}
                </Stack>
            </Stack>
        </FormControl>
    );
};

export default NumberCountryDropdown;
